import React, { useContext, useState } from 'react';
import Navbar from '../Shared/Navbar/Navbar';
import banner from '../../images/find-doctor.jpg'
import doctorImg from "../../images/doctor-img.webp"
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { context } from '../FrontPanel/FrontPanel';
import { Link } from 'react-router-dom';
const Appointment = () => {
    const [patientInfo, setPatientInfo] = useState({
        firstName: "",
        lastName: "",
        appDate: "",
        appTime: "",
        patientStatus: "",
        patientDob: "",
        phoneNo: "",
        gender: "",
        doctor: "",
        notes: ""


    });
   
    const [activeStep, setActiveStep] = useState(1);
    const handleStep = () => {
        if (activeStep === 1) {
            if (patientInfo.appDate && patientInfo.appTime && patientInfo.doctor && patientInfo.patientStatus) {
                setActiveStep(2)
            } else {
                toast.error('Please input required filed!', {
                    position: "top-right",
                    autoClose: 3000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "light",
                })
            }
        }
    }
    const handleStepTwo = () => {
        if (activeStep === 2) {
            if (patientInfo.firstName && patientInfo.phoneNo && patientInfo.patientDob && patientInfo.gender) {
                setActiveStep(3)
            } else {
                toast.error('Please input required filed!', {
                    position: "top-right",
                    autoClose: 3000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "light",
                })
            }
        }
    }
    const { pharmacyData } = useContext(context)
    const existingPatient = patientInfo.patientStatus === "Existing patient";
    console.log(existingPatient, "dd")
    return (
        <div>
            <Navbar />
            <ToastContainer />

            <div className="banner relative">
                <img className='h-80 w-full' src={banner} alt="" />
                <div className="absolute bottom-0 banner-bg w-full p-[30px]">
                    <h5 className='text-[22px]'>NEW PATIENT APPOINTMENT</h5>
                </div>
            </div>
            <div className="stepper">
                <div className="flex justify-center">
                    <ul className="steps">
                        <li className={`step ${(activeStep === 1) && "step-neutral"}`}> <span style={{ visibility: "hidden" }} className=''>Select doctor and time</span> </li>
                        <li className={`step ${activeStep === 2 && "step-neutral"}`}></li>
                        <li className={`step ${activeStep === 3 && "step-neutral"}`}></li>
                    </ul>
                </div>
            </div>
            {
                activeStep === 1 &&
                <div className="appointment-form mx-2 sm:mx-6 md:mx-12 lg:mx-20 xl-mx-28 mt-3">
                    <div className="">
                        <input type="radio"  checked={patientInfo.patientStatus==="New patient" && true} value="New patient" onChange={(e) => setPatientInfo({ ...patientInfo, patientStatus: e.target.value })} className='accent-[#134E47] mr-3 mt-1' name="pay" id="" />
                        <label className='font-semibold mr-5'>New Patient <span className='text-red-500'>*</span></label>
                        <input type="radio" checked={patientInfo.patientStatus==="Existing patient" && true} value="Existing patient" onChange={(e) => setPatientInfo({ ...patientInfo, patientStatus: e.target.value })} className='accent-[#134E47] mr-3 mt-1' name="pay" id="" />
                        <label className='font-semibold'>Existing Patient <span className='text-red-500'>*</span></label>
                    </div>
                    <div className="sm:grid grid-cols-12 gap-4">
                        <div className='col-span-8'>
                            <div className="mt-2">
                                <label className='font-semibold' > Select Doctor <span className='text-red-500'>*</span></label>
                                <select  value={patientInfo.doctor} onChange={(e) => setPatientInfo({ ...patientInfo, doctor: e.target.value })} className='w-full  px-2 py-1 bg-white border border-slate-300 rounded-md  focus:border-[#134E47] focus:outline-none'>
                                    <option value="Select Doctor"> Select Doctor</option>
                                    <option value="Dr John"> Dr John</option>
                                    <option value="Dr Doe"> Dr Doe</option>
                                </select>
                            </div>
                            <div className="mt-2 grid grid-cols-12 gap-2">
                                <div className='md:col-span-8 col-span-6'>
                                    <label className='font-semibold' > Preferred date <span className='text-red-500'>*</span></label>
                                    <input value={patientInfo.appDate}  onChange={(e) => setPatientInfo({ ...patientInfo, appDate: e.target.value })} type="date" name="" id="" className='w-full px-2 py-1 bg-white border border-slate-300 rounded-md  focus:border-[#134E47] focus:outline-none' />
                                </div>
                                <div className='md:col-span-4 col-span-6'>
                                    <label className='font-semibold' > Preferred time <span className='text-red-500'>*</span></label>
                                    <select value={patientInfo.appTime} onChange={(e) => setPatientInfo({ ...patientInfo, appTime: e.target.value })} className='w-full  px-2 py-1 bg-white border border-slate-300 rounded-md  focus:border-[#134E47] focus:outline-none'>
                                        <option value="Select time">Select time</option>
                                        <option value="9.00 AM"> 9.00 AM</option>
                                        <option value="10.00 AM"> 10.00 AM</option>
                                        <option value="11.00 AM"> 11.00 AM</option>
                                        <option value="12.00 PM"> 12.00 PM</option>
                                    </select>
                                </div>
                            </div>
                            <div className='mt-2'>
                                <label className='font-semibold' > Notes</label>
                                <textarea onChange={(e) => setPatientInfo({ ...patientInfo, notes: e.target.value })} placeholder='Write here' className='w-full bg-white border border-slate-300 rounded-md px-2 py-1 focus:border-[#134E47] focus:outline-none' name="" id="" cols="30" rows="5"></textarea>
                            </div>
                            <button onClick={handleStep} className="mt-2 px-8 mb-3 py-1 bg-[#134E47] text-white font-medium rounded-lg">Next</button>
                        </div>
                        <div className="col-span-4 ">
                            <div className="md:w-80 mx-auto custom-card p-2">
                                <div className="px-7 pt-7 flex justify-center">
                                    <img src={doctorImg} alt="Shoes" className="rounded-full h-[150px]" />
                                </div>
                                <div className="items-center text-center">
                                    <h2 className="text-gray-500 font-bold">Mr. John</h2>
                                    <hr className='border-dotted border-t-2' />
                                    <p className='text-sm font-semibold'>General practitioner</p>
                                    <div className="doctors-schedule">
                                        <table className='w-full'>
                                            <tr className='py-4 px-2 bg-[#E5E6E6]'>
                                                <td>Day</td>
                                                <td>Time</td>
                                                <td>Location</td>
                                            </tr>
                                            <tr>
                                                <td>Fri</td>
                                                <td>05 : 00 PM</td>
                                                <td>New York</td>
                                            </tr>
                                            <tr>
                                                <td>Fri</td>
                                                <td>05 : 00 PM</td>
                                                <td>New York</td>
                                            </tr>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            }
            {
                activeStep === 2 &&
                <div className='mx-2 sm:mx-6 md:mx-12 lg:mx-36 xl-mx-48 mt-3'>
                    {
                       existingPatient &&
                        <div className="flex justify-center mb-2">
                            <div className="form-control">
                                <div className="input-group">
                                    <input type="text" placeholder="Mobile number" className="input input-bordered  focus:border-[#134E47] focus:outline-none" />
                                    <button className="btn btn-square">
                                        <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" /></svg>
                                    </button>
                                </div>
                            </div>
                        </div>
                    }
                    <div className="grid grid-cols-2 gap-4">
                        <div>
                            <div className=''>
                                <label className='font-semibold' > First Name <span className='text-red-500'>*</span></label>
                                <input type="text" value={patientInfo.firstName}  onChange={(e) => setPatientInfo({ ...patientInfo, firstName: e.target.value })} className='w-full  px-2 py-1 bg-white border border-slate-300 rounded-md  focus:border-[#134E47] focus:outline-none' />
                            </div>
                            <div className='mt-2'>
                                <label className='font-semibold' > Phone <span className='text-red-500'>*</span></label>
                                <input type="text" value={patientInfo.phoneNo} onChange={(e) => setPatientInfo({ ...patientInfo, phoneNo: e.target.value })} className='w-full  px-2 py-1 bg-white border border-slate-300 rounded-md  focus:border-[#134E47] focus:outline-none' />
                            </div>
                            <div className='mt-2'>
                                <label className='font-semibold' > DOB <span className='text-red-500'>*</span></label>
                                <input type="date" value={patientInfo.patientDob} onChange={(e) => setPatientInfo({ ...patientInfo, patientDob: e.target.value })} className='w-full  px-2 py-1 bg-white border border-slate-300 rounded-md  focus:border-[#134E47] focus:outline-none' />
                            </div>
                        </div>
                        <div>
                            <div className=''>
                                <label className='font-semibold' > Last Name </label>
                                <input type="text" value={patientInfo.lastName} onChange={(e) => setPatientInfo({ ...patientInfo, lastName: e.target.value })} className='w-full  px-2 py-1 bg-white border border-slate-300 rounded-md  focus:border-[#134E47] focus:outline-none' />
                            </div>
                            <div className='mt-2'>
                                <label className='font-semibold' > Email </label>
                                <input type="text" value={patientInfo.email} onChange={(e) => setPatientInfo({ ...patientInfo, email: e.target.value })} className='w-full  px-2 py-1 bg-white border border-slate-300 rounded-md  focus:border-[#134E47] focus:outline-none' />
                            </div>
                            <div className='mt-2'>
                                <label className='font-semibold' > Gender <span className='text-red-500'>*</span></label>
                                <select value={patientInfo.gender} onChange={(e) => setPatientInfo({ ...patientInfo, gender: e.target.value })} className='w-full  px-2 py-1 bg-white border border-slate-300 rounded-md  focus:border-[#134E47] focus:outline-none'>
                                    <option value="Select Gender">Select Gender</option>
                                    <option value="Male"> Male</option>
                                    <option value="Female"> Female</option>
                                    <option value="Others"> Others</option>
                                </select>
                            </div>
                        </div>

                    </div>
                    <div className="flex justify-between">
                        <button onClick={() => setActiveStep(1)} className="mt-2 px-8 mb-3 py-1 bg-[#134E47] text-white font-medium rounded-lg">Back</button>
                        <button onClick={handleStepTwo} className="mt-2 px-8 mb-3 py-1 bg-[#134E47] text-white font-medium rounded-lg">Request for an appointment</button>
                    </div>
                </div>
            }
            {
                activeStep === 3 &&
                <div className="text-center">
                    <div className="md:w-[800px] mx-auto text-center py-1 px-1 custom-card">
                        <h6 className='text-[#134E47] bg-[#E5E6E6] font-bold text-lg'>Complete</h6>
                        <p className='font-semibold mt-2'>Please note that this is not your appointment confirmation.</p>
                        <p className='font-semibold mt-2'>Due to increase in inquries being received, three may be a delay in our response. We will be contacting you as soon as possible.</p>
                        <p><span className='font-bold mt-2'>Serial Number : </span> 119</p>
                        <p className="font-bold text-[#134E47] text-lg mt-2">Thank you !!</p>
                        <Link to={`/medicine-list/${pharmacyData.id}`}>
                            <button onClick={handleStepTwo} className="mt-2 px-8 mb-3 py-1 bg-[#134E47] text-white font-medium rounded-lg">Back to home</button>
                        </Link>
                    </div>

                </div>
            }
        </div>
    );
};

export default Appointment;